export const GET_ENTRY_STRATEGY_BY_ID = 'GET_ENTRY_STRATEGY_BY_ID';
export const GET_ENTRY_STRATEGY_BY_ID_SUCCESSFUL = 'GET_ENTRY_STRATEGY_BY_ID_SUCCESSFUL';
export const GET_ENTRY_STRATEGY_BY_ID_FAILED = 'GET_ENTRY_STRATEGY_BY_ID_FAILED';
